/* Grihvas bulk savings, made visible everywhere:
   - product page: savings strip under the price, "25+ = 20%" bulk order card, unlock acknowledgement
   - every page: after anything is added to the bag, a pill shows which bulk discount is unlocked and what's next
   - product page: WhatsApp community invite (replaces "Order on WhatsApp") */
(function () {
  var TIERS = [[3, 5], [5, 10], [10, 15], [25, 20]];
  var MIN = 25, PCT = 20, WA = '919891736601';
  var COMMUNITY = 'https://wa.me/' + WA + '?text=' + encodeURIComponent('Hi Grihvas! Please add me to your WhatsApp community for offers and new arrivals.');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TAG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
  function fmt(c) { var v = Math.round(c) / 100; return '₹' + v.toLocaleString('en-IN', { maximumFractionDigits: v % 1 ? 2 : 0 }); }
  function tierFor(n) { var t = null; TIERS.forEach(function (x) { if (n >= x[0]) t = x; }); return t; }
  function nextFor(n) { for (var i = 0; i < TIERS.length; i++) { if (n < TIERS[i][0]) return TIERS[i]; } return null; }

  /* ---------- product page ---------- */
  function initProduct() {
    var gp = document.querySelector('gv-product');
    if (!gp) return;
    var form = document.getElementById('GvProductForm');
    var tiers = gp.querySelector('.gv-tiers');

    /* community invite instead of Order on WhatsApp */
    gp.querySelectorAll('.gv-buy-wa').forEach(function (a) { a.remove(); });
    if (form && !gp.querySelector('.gv-community')) {
      var c = document.createElement('a');
      c.className = 'gv-community';
      c.href = COMMUNITY; c.target = '_blank'; c.rel = 'noopener';
      c.innerHTML = '<span class="gv-community__ic" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.4 14.1c-.2.6-1.3 1.2-1.8 1.3-.5.1-1 .1-3.2-.7-2.7-1.1-4.4-3.8-4.6-4-.1-.2-1.1-1.5-1.1-2.8 0-1.3.7-2 1-2.3.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .5l-.4.6-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.3 2.4 1.5.3.1.5.1.6-.1l.9-1.1c.2-.3.4-.2.6-.1l1.9.9c.3.1.5.2.5.3.1.2.1.6-.1 1.2z"/></svg></span>' +
        '<span class="gv-community__txt"><b>Join the Grihvas WhatsApp community</b><small>Early festive drops and members-only deals. No spam.</small></span>' +
        '<span class="gv-community__go">Join</span>';
      form.insertAdjacentElement('afterend', c);
    }
    if (!tiers || gp.querySelector('.gv-bulkstrip')) return;

    /* savings strip right under the price */
    var price = gp.querySelector('.gv-pdp-price');
    var strip = document.createElement('button');
    strip.type = 'button';
    strip.className = 'gv-bulkstrip';
    var chips = TIERS.map(function (t) { return '<span class="gv-bulkstrip__chip" data-q="' + t[0] + '">' + t[0] + '+ <b>' + t[1] + '%</b></span>'; }).join('');
    strip.innerHTML = '<span class="gv-bulkstrip__head">' + TAG + '<span data-gv-strip-msg>Bulk savings · buy more, pay less</span></span><span class="gv-bulkstrip__chips">' + chips + '</span>';
    strip.addEventListener('click', function () { tiers.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    if (price) price.insertAdjacentElement('afterend', strip); else tiers.parentNode.insertBefore(strip, tiers);

    /* bulk order card: 25+ pcs = 20% off */
    var tierIn = document.createElement('input');
    tierIn.type = 'radio'; tierIn.name = 'gv_tier'; tierIn.value = String(MIN);
    tierIn.setAttribute('data-gv-tier', ''); tierIn.dataset.pct = String(PCT); tierIn.hidden = true; tierIn.tabIndex = -1;
    var title = ((document.querySelector('.gv-info h1') || {}).textContent || 'your product').trim();
    var msg = 'Hi Grihvas, I want a bulk quote for: ' + title + ' ' + location.href.split('?')[0] + ' . Quantity: __ pcs. Custom branding: yes/no. Delivery city & date: __';
    var box = document.createElement('div');
    box.className = 'gv-bulk';
    box.innerHTML =
      '<div class="gv-bulk__head"><span class="gv-bulk__tag">Bulk order</span><span class="gv-bulk__deal"><b>' + MIN + '+ pcs</b> · ' + PCT + '% off</span></div>' +
      '<p class="gv-bulk__line"><span data-gv-bulk-each></span> each · <span data-gv-bulk-total></span> for ' + MIN + ' pcs <span class="gv-bulk__save" data-gv-bulk-save></span></p>' +
      '<div class="gv-bulk__btns"><button type="button" class="gv-btn gv-bulk__add" data-gv-bulk-add>Add ' + MIN + ' to bag</button>' +
      '<a class="gv-bulk__quote" href="https://wa.me/' + WA + '?text=' + encodeURIComponent(msg) + '" target="_blank" rel="noopener">100+ pcs or custom logo? Get a quote</a></div>' +
      '<p class="gv-bulk__fine">Discount applies automatically in your bag. Mix and match any Bulk Saver items to reach ' + MIN + '.</p>';
    box.appendChild(tierIn);
    tiers.appendChild(box);
    if (Array.isArray(gp.tiers)) gp.tiers.push(tierIn);

    var lastPct = 0;
    function paint() {
      var cents = gp.cents || parseInt(gp.dataset.cents || '0', 10);
      var each = Math.round(cents * (100 - PCT) / 100);
      box.querySelector('[data-gv-bulk-each]').textContent = fmt(each);
      box.querySelector('[data-gv-bulk-total]').textContent = fmt(each * MIN);
      box.querySelector('[data-gv-bulk-save]').textContent = '(save ' + fmt((cents - each) * MIN) + ')';
      var qEl = gp.querySelector('[data-gv-qty]');
      var n = qEl ? Math.max(1, parseInt(qEl.value, 10) || 1) : 1;
      var t = tierFor(n), nx = nextFor(n);
      box.classList.toggle('is-on', n >= MIN);
      strip.classList.toggle('is-on', !!t);
      strip.querySelectorAll('.gv-bulkstrip__chip').forEach(function (ch) { ch.classList.toggle('is-on', !!t && parseInt(ch.dataset.q, 10) === t[0]); });
      var m = strip.querySelector('[data-gv-strip-msg]');
      if (t) m.innerHTML = '<b>' + t[1] + '% bulk discount unlocked</b> on ' + n + ' pcs' + (nx ? ' · ' + (nx[0] - n) + ' more for ' + nx[1] + '%' : '');
      else m.textContent = 'Bulk savings · buy ' + TIERS[0][0] + '+ and save ' + TIERS[0][1] + '%, up to ' + PCT + '%';
      var pct = t ? t[1] : 0;
      if (pct > lastPct) { strip.classList.remove('is-pop'); void strip.offsetWidth; strip.classList.add('is-pop'); }
      lastPct = pct;
      var btn = gp.querySelector('[data-gv-add]');
      box.querySelector('[data-gv-bulk-add]').disabled = !!(btn && btn.disabled && !btn.classList.contains('is-loading'));
    }
    paint();
    document.addEventListener('gv:product-change', paint);
    box.querySelector('[data-gv-bulk-add]').addEventListener('click', function () {
      var qEl = gp.querySelector('[data-gv-qty]');
      var cur = qEl ? parseInt(qEl.value, 10) || 1 : 1;
      if (typeof gp.setQty === 'function') gp.setQty(Math.max(cur, MIN), 1); else if (qEl) qEl.value = Math.max(cur, MIN);
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    });
  }

  /* ---------- bag progress pill (all pages) ---------- */
  var bulkHandles = null;
  function loadHandles() {
    if (bulkHandles) return Promise.resolve(bulkHandles);
    try { var s = sessionStorage.getItem('gvBulkHandles'); if (s) { bulkHandles = JSON.parse(s); return Promise.resolve(bulkHandles); } } catch (e) {}
    return fetch(root + 'collections/bulk-savers/products.json?limit=250').then(function (r) { return r.json(); }).then(function (j) {
      bulkHandles = (j.products || []).map(function (p) { return p.handle; });
      try { sessionStorage.setItem('gvBulkHandles', JSON.stringify(bulkHandles)); } catch (e) {}
      return bulkHandles;
    }).catch(function () { bulkHandles = []; return bulkHandles; });
  }
  var pill, pillT, lastCount = -1;
  function showPill(html, done) {
    if (!pill) { pill = document.createElement('div'); pill.className = 'gv-bulkpill'; pill.setAttribute('role', 'status'); pill.setAttribute('aria-live', 'polite'); document.body.appendChild(pill); }
    pill.classList.toggle('is-done', !!done);
    pill.innerHTML = html;
    pill.classList.add('is-on');
    clearTimeout(pillT);
    pillT = setTimeout(function () { pill.classList.remove('is-on'); }, 4200);
  }
  function checkBag() {
    Promise.all([fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }), loadHandles()]).then(function (res) {
      var cart = res[0], hs = res[1] || [];
      var n = 0;
      (cart.items || []).forEach(function (it) { if (hs.indexOf(it.handle) > -1) n += it.quantity; });
      if (n === lastCount) return;
      lastCount = n;
      if (!n) return;
      var t = tierFor(n), nx = nextFor(n);
      var bar = nx ? '<span class="gv-bulkpill__bar"><i style="width:' + Math.min(100, Math.round(n / nx[0] * 100)) + '%"></i></span>' : '';
      if (t && nx) showPill('<b>🎉 ' + t[1] + '% bulk discount unlocked</b><span>Add ' + (nx[0] - n) + ' more for ' + nx[1] + '% off</span>' + bar, true);
      else if (t) showPill('<b>🎉 ' + t[1] + '% bulk discount unlocked</b><span>Best price on ' + n + ' items, applied in your bag</span>', true);
      else showPill('<b>Add ' + (nx[0] - n) + ' more to save ' + nx[1] + '%</b><span>Bulk savings on ' + nx[0] + '+ items, up to ' + PCT + '% off</span>' + bar, false);
    }).catch(function () {});
  }
  /* watch the bag: any add / change call triggers a check */
  if (window.fetch && !window.__gvBulkFetch) {
    window.__gvBulkFetch = true;
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1) p.then(function () { setTimeout(checkBag, 250); }).catch(function () {});
      return p;
    };
  }
  /* remember the current count so the pill only reacts to changes */
  function primeCount() {
    Promise.all([fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }), loadHandles()]).then(function (res) {
      var n = 0; (res[0].items || []).forEach(function (it) { if ((res[1] || []).indexOf(it.handle) > -1) n += it.quantity; }); lastCount = n;
    }).catch(function () {});
  }

  function init() { primeCount(); customElements.whenDefined('gv-product').then(initProduct); if (!document.querySelector('gv-product')) initProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();